<h1>{{'academy.Main_interests'|translate}}</h1>
<div class="themes">
	<div id="update-success" class="alert alert-success alert-dismissable" *ngIf="updated">
		<button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="updated = false">×</button>
		{{'account.Update_success_flash'|translate}}
	</div>
	<app-main-interests (updated)="updatedUser($event)"></app-main-interests>
</div>
